import api from "../../../../../BasicComponent/Service/api";
import { CHECKLIST_BUILDER_URL } from "../../../../utils/constService";

export const fetchBuilders = (params) =>
  api.get(CHECKLIST_BUILDER_URL, { params });

/** Returns only the LATEST revision per template — used by execution form */
export const fetchBuildersByProductId = (productId) =>
  api.get(`${CHECKLIST_BUILDER_URL}/get-by-product-id/${productId}`);

/** Returns ALL revisions of every template — used by binding modal */
export const fetchAllBuildersByProductId = (productId) =>
  api.get(`${CHECKLIST_BUILDER_URL}/get-all-by-product-id/${productId}`);

export const fetchBuilderById = (uuid) =>
  api.get(`${CHECKLIST_BUILDER_URL}/${uuid}`);

export const postBuilder = (data) =>
  api.post(CHECKLIST_BUILDER_URL, data);

export const putBuilder = (data, uuid) =>
  api.put(`${CHECKLIST_BUILDER_URL}/${uuid}`, data);

export const deleteBuilder = (uuid) =>
  api.delete(`${CHECKLIST_BUILDER_URL}/${uuid}`);